import inject from '@src/initialize/inject-scripts/libs/inject';
import * as configs from '@src/initialize/inject-scripts/configs';

const injectScripts = () => inject(configs);
export default injectScripts;
